import React from 'react';
import ReactDOM from 'react-dom/client';
// antd 5's static APIs (message.*, notification.*, Modal.confirm) render via
// ReactDOM.render, which React 19 removed — without this patch every toast in
// the app silently renders nothing.
import '@ant-design/v5-patch-for-react-19';
import './index.css';
import { i18nReady } from './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// The locale tree is fetched separately (see i18n.ts), so mount only once it
// has landed. createRoot clears #root on its first render, so waiting here also
// keeps the prerendered SEO body on screen until there is a real page to swap
// in — rendering earlier would flash raw translation keys.
//
// The catch matters: a locale request that fails (offline, or a chunk pruned by
// a deploy while the tab was open) must not leave a permanent white screen.
// Mounting anyway shows raw keys, but the page stays navigable and a reload
// recovers.
i18nReady.catch(() => undefined).then(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
